import { ChangeEventHandler, useEffect, SVGAttributes } from "react"
import { timestampToReadableString } from "../Utilities/dateStrings"
import './TimePicker.less'


const ClockIcon = ({className}: SVGAttributes<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox="0 0 16 16"
    preserveAspectRatio="xMidYMid meet"
    xmlns="http://www.w3.org/2000/svg"
    className={className}>
    <path d="m8.00754,0.06669c-4.38042,0 -7.93266,3.55727 -7.93266,7.94442c0,4.38715 3.55225,7.94442
      7.93266,7.94442c4.38042,0 7.93266,-3.55727 7.93266,-7.94442c0,-4.38715 -3.55225,-7.94442
      -7.93266,-7.94442zm0,14.54116c-3.63712,0 -6.58728,-2.95437 -6.58728,-6.59673c0,-3.64236
      2.95015,-6.59673 6.58728,-6.59673c3.63712,0 6.58728,2.95437 6.58728,6.59673c0,3.64236
      -2.95015,6.59673 -6.58728,6.59673z" fill="currentColor" />
    <path d="m11.91458,10.12591l-3.183,-2.3014l0,-5.5245c0,-0.0983 -0.08,-0.1786 -0.178,
      -0.1786l-1.074,0c-0.098,0 -0.178,0.0803 -0.178,0.1786l0,6.1473c0,0.058 0.026,0.1116
      0.073,0.1451l3.692,2.6919c0.081,0.0581 0.192,0.0402 0.25,-0.0379l0.639,-0.8705c0.058,-0.0826
      0.04,-0.1942 -0.041,-0.25z" fill="currentColor" />
  </svg>
)
const timeStamps: string[] = []

for (let i=0; i<24; i+=0.5) {
  const hours = i < 10 ? `0${Math.floor(i)}` : Math.floor(i).toString()
  const mins = i % 1 == 0 ? '00' : '30'
  timeStamps.push(`${hours}:${mins}:00`)
}

interface TimePickerProps extends Partial<Omit<HTMLSelectElement, 'value'>> {
  value: string
  setValue: (val: string) => void
  baseValue?: string
}

const TimePicker = ({id, value, setValue, required, baseValue}: TimePickerProps) => {
  const onChange: ChangeEventHandler<HTMLSelectElement> = ({target}) => setValue(target.value)
  
  const selectableTimes = baseValue === undefined ? timeStamps :
    timeStamps.slice(timeStamps.indexOf(baseValue) + 1)
  
  useEffect(()=>{ // change the set value if blank or <= baseValue
    if(value === '' || baseValue && value <= baseValue) {
      setValue(selectableTimes[0] ?? '')
    }
  }, [value, baseValue])

  return (
    <div className="time-picker-wrapper">
      <select
        id={id}
        value={value}
        onChange={onChange}
        required={required}
        className='time-picker-input'
        >
        { selectableTimes.map(timeStamp => (
          <option key={timeStamp} value={timeStamp}>
            {timestampToReadableString(timeStamp)}
          </option>
          )) }
      </select>
      <ClockIcon className="clock-icon" aria-hidden='true'/>
    </div>
  )
}

export default TimePicker
